import Header from '@/pages/home/components/Header';
import HeroSection from '@/pages/home/components/HeroSection';
import ContactSection from '@/pages/home/components/ContactSection';
import CardsSection from '@/pages/home/components/CardsSection';
import UpdatesSection from '@/pages/home/components/UpdatesSection';
import IndexSection from '@/pages/home/components/IndexSection';
import CarouselSection from '@/pages/home/components/CarouselSection';
import AppSection from '@/pages/home/components/AppSection';
import RankingSection from '@/pages/home/components/RankingSection';
import FaqSection from '@/pages/home/components/FaqSection';
import AboutSection from '@/pages/home/components/AboutSection';
import FeaturesSection from '@/pages/home/components/FeaturesSection';
import MediaSection from '@/pages/home/components/MediaSection';
import TopicsSection from '@/pages/home/components/TopicsSection';
import CommentsSection from '@/pages/home/components/CommentsSection';
import Footer from '@/pages/home/components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <HeroSection />
        <ContactSection />
        <CardsSection />
        <UpdatesSection />
        <IndexSection />
        <CarouselSection />
        <AppSection />
        <RankingSection />
        <FaqSection />
        <AboutSection />
        <FeaturesSection />
        <MediaSection />
        <TopicsSection />
        <CommentsSection />
      </main>
      <Footer />
    </div>
  );
}